export const MESSENGER_FORM_FIELDS = [
  "integrationsMessengerEnabled",
  "integrationsMessengerPageAccessToken",
  "integrationsMessengerPageAccessTokenConfigured",
];

const normalizeToken = (value) =>
  typeof value === "string" ? value : "";

export const getMessengerDraftValues = (values) =>
  Object.fromEntries(
    MESSENGER_FORM_FIELDS.map((fieldName) => [fieldName, values?.[fieldName]])
  );

export const getMessengerFormValues = (integration) => {
  const tokenConfigured = integration?.config?.pageAccessTokenConfigured === true;

  return {
    integrationsMessengerEnabled: integration?.enabled === true,
    integrationsMessengerPageAccessToken: "",
    integrationsMessengerPageAccessTokenConfigured: tokenConfigured,
  };
};

const getMessengerFingerprint = (values) =>
  JSON.stringify({
    enabled: values?.integrationsMessengerEnabled === true,
    pageAccessToken: normalizeToken(values?.integrationsMessengerPageAccessToken),
  });

export const hasMessengerIntegrationChanges = (values, integration) =>
  getMessengerFingerprint(values) !==
  getMessengerFingerprint(getMessengerFormValues(integration));

export const buildMessengerIntegrationPayload = (values) => {
  const enabled = values?.integrationsMessengerEnabled === true;
  const payload = {
    type: "messenger",
    enabled,
    configVersion: 1,
  };

  const pageAccessToken = normalizeToken(values?.integrationsMessengerPageAccessToken);
  if (pageAccessToken.trim()) {
    payload.config = { pageAccessToken };
  }

  return payload;
};
